import { render, staticRenderFns } from "./CategoryDetail.vue?vue&type=template&id=308efe3c&scoped=true&"
var script = {}
import style0 from "./CategoryDetail.vue?vue&type=style&index=0&id=308efe3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308efe3c",
  null
  
)

export default component.exports